import React from "react";
import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    dsn: "https://821f99cd27e44bdead691e56c12ebbe5@o360459.ingest.sentry.io/6590983",
  });
}
